module.exports = __webpack_public_path__ + "static/img/sm2.a66f18a.png";


//////////////////
// WEBPACK FOOTER
// ./static/sm2.png
// module id = urtE
// module chunks = 1